import React from 'react';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

import {
  getDeclinationCopyByStatus,
  resolveDeclinationStatus
} from '../DeclinationReasonsDrawer/DeclinationReasons.shared';
import {
  buildReasonDetailsPayload,
  getReasonDetailsFormValues,
  isRetryableStatusCode
} from '../DeclinationReasonsDrawer/DeclinationReasonsDrawer.utils';
import { DeclinationReasonsDrawerBase } from '../DeclinationReasonsDrawer/DeclinationReasonsDrawerBase';

export const SendoverDeclinationReasonsDrawer = ({
  initialValues,
  isSubmitting = false,
  onClose = () => {},
  onSaved = () => {},
  status
}) => {
  const declinationStatus = resolveDeclinationStatus(status?.id);

  const { state, refreshData } = useFetchWithStatusV2({
    endpoint: declinationStatus ? `${Endpoints.SendoutReasons}?statusId=${status?.id}` : null
  });

  if (!declinationStatus) return null;

  const { title } = getDeclinationCopyByStatus(declinationStatus);

  const reasonOptions = state.status === UIStatus.Success ? state.results : [];
  const isLoadingReasons = state.status === UIStatus.Loading;
  const hasReasonsError = state.status === UIStatus.Error || state.status === UIStatus.Empty;
  const canRetryReasons =
    state.status === UIStatus.Error && isRetryableStatusCode(state.responseStatusCode);

  const buildPayload = formValues =>
    buildReasonDetailsPayload({ statusId: status?.id, formValues });

  return (
    <DeclinationReasonsDrawerBase
      buildPayload={buildPayload}
      defaultValues={getReasonDetailsFormValues(initialValues)}
      hasReasonsError={hasReasonsError}
      isLoadingReasons={isLoadingReasons}
      isSubmitting={isSubmitting}
      onClose={onClose}
      onRetryReasons={canRetryReasons ? refreshData : undefined}
      onSaved={onSaved}
      reasons={reasonOptions}
      title={title}
    />
  );
};
